import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  breakdowns: [],
};


const slice = createSlice({
  name: 'breakdown',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET breakdown
    getBreakdownSuccess(state, action) {
      state.isLoading = false;
      state.breakdowns = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;


// ----------------------------------------------------------------------

export function getBreakdowns() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`admin/breakdown/view`);
      dispatch(slice.actions.getBreakdownSuccess(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



